/**
 * Voice-originated customers usually have no email, but the customer record
 * requires one, so ticket-service fabricates a placeholder of the shape
 * `phone_<digits>@voice.centraoneplus.local` (see
 * centraOnePlus-ticket-service voice-event.consumer.ts). The `.local` domain is
 * non-routable and the address is not the customer's — it only stands in for
 * "no email on file". The UI must never present it as a real email, and
 * outbound-email flows must never send to it.
 */
const VOICE_PLACEHOLDER_DOMAIN = '@voice.centraoneplus.local';

/** True when `email` is a synthetic voice placeholder rather than a real address. */
export function isPlaceholderEmail(email?: string | null): boolean {
  return (
    typeof email === 'string' &&
    email.toLowerCase().trim().endsWith(VOICE_PLACEHOLDER_DOMAIN)
  );
}

/** The email to display, or `null` when it is a synthetic placeholder. */
export function realEmailOrNull(email?: string | null): string | null {
  return isPlaceholderEmail(email) ? null : (email ?? null);
}
